"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemovePostDialog = RemovePostDialog;
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _CircularProgress2 = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Dialog3 = _interopRequireDefault(require("@mui/material/Dialog"));
var _notistack = require("notistack");
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _components = require("../components");
var _services = require("../services");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function RemovePostDialog({
  Dialog: _Dialog,
  currentPartner,
  geogroup,
  newsPost,
  handleClose,
  ...props
}) {
  const [loading, setLoading] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    enqueueSnackbar
  } = (0, _notistack.useSnackbar)();
  async function handleRemove() {
    if (!geogroup || !newsPost) return;
    setLoading(true);
    try {
      await _services.GeogroupService.removeNewsPost(geogroup.id, newsPost, currentPartner);
      handleClose(true);
      enqueueSnackbar(t('commons.news.remove_dialog.success'));
    } catch {
      enqueueSnackbar(t('commons.news.remove_dialog.server_error'), {
        variant: 'error'
      });
    }
    setLoading(false);
  }
  const Dialog = _Dialog || _Dialog3.default;
  return /*#__PURE__*/_react.default.createElement(Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: handleClose
  }, props), /*#__PURE__*/_react.default.createElement(_DialogContent2.default, {
    sx: _Dialog ? {
      padding: 0
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.1rem",
    fontWeight: 600
  }, t('commons.news.remove_dialog.title'))), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, t('commons.news.remove_dialog.description')), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "primary",
    disabled: loading,
    onClick: () => handleClose(),
    size: "large",
    startIcon: /*#__PURE__*/_react.default.createElement(_Close2.default, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "outlined"
  }, t('commons.actions.cancel')), /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "error",
    disabled: loading,
    onClick: handleRemove,
    size: "large",
    startIcon: loading ? /*#__PURE__*/_react.default.createElement(_CircularProgress2.default, {
      color: "inherit",
      size: 16,
      thickness: 4
    }) : /*#__PURE__*/_react.default.createElement(_components.RemoveIcon, null),
    sx: {
      borderRadius: '8px !important'
    },
    variant: "outlined"
  }, t('commons.news.remove_dialog.actions.remove'))))));
}